import React from 'react'
import { getMeData } from '../../utils'
import { getMsr, GET_PDR_REQUIREMENTS_QUERY } from '../../queries/member'
import PDRCredits, { LoadingMSR } from './PDRCredits'
import NewPDRCredits from './NewPDRCredits'
import CompactPDR from './CompactView/CompactPDR'
import NewCompactPDR from './CompactView/NewCompactPDR'
import ErrorLoading from './ErrorLoading'
import WrapWithFetch from '../WrapWithFetch'
import { COACH_TOOLS_API } from '../../../apolloClient'

const PDRBrief = WrapWithFetch(({
  me,
  loading,
  isFetching,
  error,
  refetch,
  reload
}) => {
  if (loading || isFetching) {
    return <LoadingMSR />
  } else if (error || !me) {
    return (
      <ErrorLoading />
    )
  }
  return (
    <PDRCredits me={me} />
  )
})

export default getMeData(getMsr)(PDRBrief)
export const CompactPDRBrief = getMeData(getMsr)(CompactPDR)

const NewPDRBrief = WrapWithFetch(({
  data,
  me,
  loading,
  isFetching,
  error,
  refetch,
  reload
}) => {
  const { currentPerson } = data
  if (loading || isFetching) {
    return <LoadingMSR />
  } else if (error || !currentPerson) {
    return (
      <ErrorLoading />
    )
  }
  return (
    <NewPDRCredits currentPerson={currentPerson} />
  )
})

const context = { api: COACH_TOOLS_API }

export const NewMSRCreditsBrief = getMeData(GET_PDR_REQUIREMENTS_QUERY, context)(NewPDRBrief)
export const NewCompactPDRBrief = getMeData(GET_PDR_REQUIREMENTS_QUERY, context)(NewCompactPDR)
